// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfHour as fn } from "../startOfHour.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfHourWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default startOfHourWithOptions;
